export default "__VITE_ASSET__DeCtutxL__"